// fonts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        header: {
            fontFamily: '"Archivo Black",  sans-serif',
            fontWeight: 200,
        },
        main_en: {
            fontFamily: '"Archivo Black",  sans-serif',
            fontWeight: 900,
        },
        main_jp: {
            fontFamily: '"M PLUS 2",  sans-serif',
        },
        footer: {
            fontWeight: 800,
        }
    },
    palette: {
        header: {
            color: '#ffffff',
            bgColor: '#c45347',
        },
    },
});

export default theme;
